/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "Đang tải"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var viVN = Object.assign(TranslationProviderComponent, {
  translations
});

export { viVN as v };
//# sourceMappingURL=vi-VN-CQnSOkLq.js.map
